import React from 'react';
import AddEditMySessions from '@components/doctor-routes/AddEditMySessions';

export default function Calendar(props) {
  return <AddEditMySessions {...props} />;
}
